<template>
  <picker
    :id="id"
    :label="id"
    :text="value"
    :skeleton="skeleton"
    :error="error"
    class="picker--value"
    data-cy-value-picker
  >
    <div
      v-if="skeleton"
      class="picker__elements d-inline-flex flex-wrap justify-center align-center"
    >
      <label v-if="label" :for="id" class="text-base mr-1 w-600">{{
        label
      }}</label>
      <picker-item
        v-for="(_, index) in values"
        :key="index"
        :name="`${id}`"
        :value="`${index}`"
        skeleton
      />
    </div>
    <div
      v-else
      class="picker__elements d-inline-flex flex-wrap justify-center align-center"
    >
      <label v-if="label" :for="id" class="text-base mr-1 w-600">{{
        label
      }}</label>

      <picker-item
        v-for="v in values"
        :key="v.opt[dimension].value"
        :name="`${id}`"
        :value="v.opt[dimension].value"
        :label="v.opt[dimension].label"
        :active="isActive(v.opt[dimension].value)"
        :stripe="!v.available"
        @input="selectValue(v.opt[dimension].value)"
      />

      <picker-item
        v-if="none"
        :name="`${id}`"
        value="none"
        :label="$t(`purchase.no.${id}`)"
        :active="isValueEmpty"
        @click="selectValue()"
      />
    </div>
  </picker>
</template>

<script>
import Picker from '@/components/picker/Picker'
import PickerItem from '@/components/picker/PickerItem'

export default {
  name: 'ValuePicker',
  components: {
    Picker,
    PickerItem,
  },
  props: {
    value: { type: String, required: true },
    /**
     * Liste des éléments
     */
    values: {
      type: Array,
      required: true,
    },
    /**
     * La dimension à afficher
     */
    dimension: {
      type: String,
      default: 'size',
    },
    /**
     * identifiant du size picker
     */
    id: {
      type: String,
      default: 'size',
    },
    /**
     * Permet d'afficher un label devant les éléments
     */
    label: {
      type: String,
      default: undefined,
    },
    /**
     * Permet d'ajouter un élément pour retirer un choix
     */
    none: {
      type: Boolean,
      default: false,
    },
    /**
     * Le composant est-il en erreur
     */
    error: {
      type: Boolean,
      default: false,
    },
    /**
     * Le composant est affiché en squelette de chargement
     */
    skeleton: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isValueEmpty() {
      return (
        this.value &&
        Object.keys(this.value).length === 0 &&
        Object.getPrototypeOf(this.value) === Object.prototype
      )
    },
  },
  methods: {
    selectValue(value) {
      if (value) {
        return this.$emit('input', value)
      }

      return this.$emit('input', '')
    },
    isActive(value) {
      if (this.value) {
        return this.value === value
      }

      return false
    },
  },
}
</script>

<style lang="scss">
.picker.picker--value {
  select {
    width: 100%;
    height: rem(40px);
    border-radius: 0;
    padding-left: rem($spacing);
    appearance: none;
    background-image: url('//cdn.shopify.com/s/files/1/1683/2271/t/14/assets/ico-select.svg?v=1474307…');
    background-repeat: no-repeat;
    background-position: right rem($spacing) center;
    background-color: transparent;
    padding-right: rem($spacing * 4);
    text-indent: 0.01px;
    cursor: pointer;
    border: 1px solid #d9d9d9;
  }
}
</style>
